import React, { useEffect } from 'react'

import './create-group.css'

import { useNavigate } from 'react-router-dom'
import { buildHttpPost } from "./utils/backendInterface.js";
import { isDev } from "./utils/helper.js";

const CreateGroup = () => {
    const navigate = useNavigate();
    let accessToken = sessionStorage.getItem("accessToken");
    let count = 0;
    let _isDev = isDev();

    useEffect(() => {
        count = count + 1;
        console.log("On page load: " + count);
        if (count === 1 && _isDev) {
            return;
        }
        displayLabels();
    }, [count]);

    if (!accessToken) {
        navigate('/sign-in');
        return;
    } else if(!sessionStorage.getItem("accessToken")) {
        return;
    }
    let pathArray = window.location.pathname.split('/');
    let companyId = pathArray[2];
    let labelCount = 1;
    let labelArray = [];

    function onchangeLabel(i, text) {
        if (text) {
            labelArray[i - 1] = text;
            if (i === labelCount) {
                labelCount++;
                displayLabel(labelCount);
            }
        } else {
            labelArray[i - 1] = null;
            if (i < labelCount) {
                console.log("Todo remove: " + i);
            }
        }
    }

    function displayLabel(i) {
        let labelContainer = document.getElementById("label-container");
        let labelBox = document.createElement("INPUT");
        labelBox.setAttribute("type", "text");
        labelBox.setAttribute("id", "label-" + i);
        labelBox.oninput = (() => {
            onchangeLabel(i, labelBox.value);
        });
        labelContainer.appendChild(labelBox);
    }

    function displayLabels() {
        let labelContainer = document.getElementById("label-container");
        for (let i = 1; i <= labelCount; i++) {
            let labelBox = document.createElement("INPUT");
            labelBox.setAttribute("type", "text");
            labelBox.setAttribute("id", "label-" + i);
            labelBox.oninput = (() => {
                onchangeLabel(i, labelBox.value);
            });
            labelContainer.appendChild(labelBox);
        }
    }

    const onSubmitHandler = (event) => {
        event.preventDefault();
        console.log('onSubmitHandler CreateGroup');
        let groupName = event.target.groupName.value;
        let groupType = event.target.groupType.value;
        let tokenOffset = event.target.tokenOffset.value;
        let tokenLength = event.target.tokenLength.value;

        let requestParams = new Map();
        //TODO throw eror when name is not filled
        requestParams.set("accessToken", accessToken);
        requestParams.set("name", groupName);
        requestParams.set("type", groupType);
        requestParams.set("tokenOffset", tokenOffset);
        requestParams.set("tokenLength", tokenLength);
        let labelList = "";
        let isFirst = true;
        labelArray.forEach(element => {
            if(element) {
                if(!isFirst) {
                    labelList += ",";
                }
                isFirst = false;
                labelList += element;
            }
        });
        requestParams.set("label", labelList);

        function alertContents(httpRequest) {
            if (httpRequest && httpRequest.readyState === XMLHttpRequest.DONE) {
                console.log("httpRequest.status: " + httpRequest.status);
                if (httpRequest.status === 200) {
                    console.log('Create group success');

                    navigate('/groups/' + companyId);
                } else if (httpRequest.status === 403) {
                    console.log("Create group denied. Status: " + httpRequest.status + " Error: " + httpRequest.thrownError);
                    alert('Login denied');
                } else {
                    alert("There was a problem with the request: ", httpRequest.status);
                }
            }
        }

        let httpRequest = buildHttpPost("companies/" + companyId + "/create-group", requestParams, alertContents);
        httpRequest.sendRequest();
    }

    return (
        <>
            <h2>Create group</h2>
            <nav id="sidebarMenu" className="collapse d-lg-block sidebar collapse bg-white">
                <div className="position-sticky">
                    <div className="list-group list-group-flush mx-3 mt-4">
                        <a href={`/companies/${companyId}/groups`} className="list-group-item list-group-item-action py-2 ripple">
                            <i className="fas fa-arrow-left fa-fw me-3"></i><span>Back to Companies</span>
                        </a>
                    </div>
                </div>
            </nav>
            <div className="content-box">
                <form id="create-group-form" onSubmit={onSubmitHandler}>
                    <div className="form-group">
                        <label>Group name</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Group name"
                            name="groupName" />
                    </div>
                    
                    <div className="form-group">
                        <label>Type</label>
                        <select id="groupType" name="groupType" className="form-control">
                            <option value="MONEY">Money</option>
                            <option value="TOKEN">Token</option>
                            <option value="TOKEN_MAX_MONEY_PER_REQUEST">Token max request amount</option>
                            <option value="TOKEN_MAX_TOTAL_MONEY">Token max total amounts</option>
                            <option value="ALWAYS_APPROVE">Always approve</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label>Token offset</label>
                         <input
                            type="text"
                            className="form-control"
                            placeholder="0"
                            name="tokenOffset" />
                    </div>

                    <div className="form-group">
                        <label>Token length</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="0"
                            name="tokenLength" />
                    </div>

                    <div className="form-group">
                        <label>Labels</label>
                        <div id="label-container"></div>
                    </div>

                    <div className="form-group">
                        <button type="submit" className="btn btn-primary submit-button">
                            Create group
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
}

export default CreateGroup;
